<script lang="ts">
  import type { Snippet } from 'svelte';
  // Standard panel surface. Optional eyebrow header and a right-aligned action slot.
  let {
    title = null,
    children,
    action,
    pad = 'p-5',
    class: cls = '',
  }: {
    title?: string | null;
    children: Snippet;
    action?: Snippet;
    pad?: string;
    class?: string;
  } = $props();
</script>

<section class="rounded-box border hair bg-base-100 {pad} {cls}">
  {#if title || action}
    <div class="mb-3 flex items-center justify-between gap-3">
      {#if title}<div class="eyebrow">{title}</div>{/if}
      {#if action}<div class="flex items-center gap-2">{@render action()}</div>{/if}
    </div>
  {/if}
  {@render children()}
</section>
